// const devConfig = {
//   salesforce: {
//     url: 'https://troy--devenv.cs106.my.salesforce.com',
//     siteUrl: 'https://devenv-troy--devenv.cs106.force.com/liveAgentSetupFlow',
//     deploymentId: '5720D0000004CFp',
//     buttonId: '5730D0000004CG4',
//     organisationId: '00D0D0000008geV',
//     baseLiveAgentURL: 'https://c.la1-c1cs-cdg.salesforceliveagent.com'
//   }
// };

const testConfig = {
  salesforce: {
    url: 'https://troy--testenv.cs108.my.salesforce.com',
    siteUrl: 'https://testenv-troy--testenv.cs108.force.com/liveAgentSetupFlow',
    deploymentId: '5721l0000008OPr',
    buttonId: '5731l0000008OR4',
    organisationId: '00D1l0000008d5k',
    baseLiveAgentURL: 'https://c.la1-c1cs-cdg.salesforceliveagent.com'
  }
};

const prodConfig = {
  salesforce: {
    url: 'https://troy.my.salesforce.com',
    siteUrl: 'https://troy--prod.secure.force.com/liveAgentSetupFlow',
    deploymentId: '5721r000000PSg1',
    buttonId: '5731r000000PSsp',
    organisationId: '00D1r000002BEzJ',
    baseLiveAgentURL: 'https://c.la1-c2-par.salesforceliveagent.com'
  }
};

export default process.env.NODE_ENV === 'production'
  ? prodConfig
  : process.env.NODE_ENV === 'development'
  ? testConfig // connect to test SF on dev (no devConfig)
  : testConfig;
